/**
 * benecosBIO Around the World – Landingpage Scripts
 * atw-scripts.js
 *
 * Beinhaltet:
 *  1. FAQ Accordion (accessible, animated)
 *  2. Smooth-Scroll für .atw-scroll-to Links
 *  3. Google Fonts Loader (Playfair Display + DM Sans)
 */

(function () {
  'use strict';

  /* ── 1. Google Fonts ────────────────────────────────────── */
  function loadFonts() {
    if (document.querySelector('[data-atw-fonts]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400&family=DM+Sans:wght@300;400;500&display=swap';
    link.setAttribute('data-atw-fonts', '');
    document.head.appendChild(link);
  }

  /* ── 2. FAQ Accordion ───────────────────────────────────── */
  function initFaq() {
    var items = document.querySelectorAll('.atw-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn    = item.querySelector('.atw-faq__q');
      var answer = item.querySelector('.atw-faq__a');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('atw-faq__item--open');

        /* Close all others */
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('atw-faq__item--open');
            var otherBtn = other.querySelector('.atw-faq__q');
            var otherAns = other.querySelector('.atw-faq__a');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
            if (otherAns) otherAns.setAttribute('hidden', '');
          }
        });

        /* Toggle this one */
        if (isOpen) {
          item.classList.remove('atw-faq__item--open');
          btn.setAttribute('aria-expanded', 'false');
          answer.setAttribute('hidden', '');
        } else {
          item.classList.add('atw-faq__item--open');
          btn.setAttribute('aria-expanded', 'true');
          answer.removeAttribute('hidden');
        }
      });
    });
  }

  /* ── 3. Smooth Scroll ───────────────────────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('.atw-scroll-to').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Init ───────────────────────────────────────────────── */
  function init() {
    loadFonts();
    initFaq();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
